import PaymentProvider from "@models/payment-provider";
import axios, { AxiosInstance } from "axios";
import { getStoredCountry, getStoredCurrency } from "../utils/cookieUtils";

export default class PaymentsAPI {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_PAYMENTS_API_URL,
    });

    this.client.interceptors.request.use((config) => {
      // Add country and currency headers to all requests
      const country = getStoredCountry();
      const currency = getStoredCurrency();
      
      if (!country || !currency) {
        console.warn('Country or currency cookies not found in API request');
      }
      
      if (country) {
        config.headers.set('country', country);
      }
      if (currency) {
        config.headers.set('currency', currency);
      }

      return config;
    });
  }

  async getPaymentProviders(partnerId: string) {
    const res = await this.client.get<any[]>("/v1/payments/providers", {
      params: {
        partner_id: partnerId,
        order_type: "store",
      },
    });
    return res.data.map((data) => new PaymentProvider(data));
  }
}
